exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".advanced-settings[data-v-9ec36ff4]{display:flex;align-items:center;position:absolute;top:50px;min-width:400px}.advanced-settings span[data-v-9ec36ff4]{flex:0 0 auto;padding:0 10px}.advanced-settings span[data-v-9ec36ff4]:first-child{padding-left:0}", ""]);

// exports
